"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.isWebOffice = exports.appConfigInstance = void 0;
var docs_config_1 = __importDefault(require("@tencent/docs-config"));
exports.appConfigInstance = docs_config_1.default
    .getInstance();
exports.isWebOffice = ['weboffice', 'paas-weboffice'].includes(exports.appConfigInstance.getConfig('domain'));
